import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import { useSmoothScroll } from "./lib/smoothScroll";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const CheckEmail = lazy(() => import("./pages/CheckEmail"));

export default function App() {
  useSmoothScroll();
  return (
    <>
      <Header />
      <Suspense fallback={<div style={{ minHeight: "100svh" }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/check-email" element={<CheckEmail />} />
        </Routes>
      </Suspense>
    </>
  );
}
